import { AppStorage, userTypes } from '@/core/Utils'

export const userTypeMixins = {
  computed: {
    userData() {
      return AppStorage.getUser()
    },
    isAdminMask() {
      return !!this.userData.token_admin
    },
    isLibrarian() {
      return this.userData?.user_type?.slug === userTypes.librarian
    },
    isIndependentTeacherBasic() {
      return this.userData?.user_type?.slug === userTypes.independentTeacherBasic
    },
    isIndependentTeacherLanguage() {
      return this.userData?.user_type?.slug === userTypes.independentTeacherLanguage
    },
    isIndependentTeacherPlayers() {
      return this.userData?.user_type?.slug === userTypes.independentTeacherPlayers
    },
    isIndependentTeacher() {
      const independentUserTypes = [
        userTypes.independentTeacherBasic,
        userTypes.independentTeacherLanguage,
        userTypes.independentTeacherPlayers
      ]
      return independentUserTypes.includes(this.userData?.user_type?.slug)
    }
  },
  methods: {
  },
};
